if (document.querySelector('.video-popup')) {
	const video = document.querySelectorAll('.video');
	const body = document.body;

	video.forEach(function (el) {
		var videoTrigger = el.querySelectorAll('.video-popup__trigger');
		var videoClose = el.querySelectorAll('.video-popup__close');
		var videoPopup = el.querySelector('.video-popup');

		videoTrigger.forEach(function (el) {
			el.addEventListener('click', function () {
				body.classList.toggle('overflow-hidden');
				videoPopup.classList.toggle('is-open');
			});
		});

		videoClose.forEach(function (el) {
			el.addEventListener('click', function () {
				body.classList.toggle('overflow-hidden');
				videoPopup.classList.toggle('is-open');
			});
		});
	});
}

if (document.querySelectorAll('.background-video')) {
	var bgvideo = document.querySelectorAll('.background-video');
	bgvideo.forEach(function (el) {
		el.muted = true;
		el.play();
	});
}
